/*
 * Лизинг оборудования — это просто и выгодно
 *
 */

import PropTypes from "prop-types";
import React from "react";

import { Box, Typography } from "@material-ui/core";
import SectionContainer from "@product-site-frontend/shared/components/SectionContainer";
import ShowMoreText from "@product-site-frontend/shared/components/ShowMoreText";
import { GatsbyImage } from "gatsby-plugin-image";
import parse from "html-react-parser";

Card.propTypes = {
  image: PropTypes.shape({
    localFile: PropTypes.object,
  }),
  index: PropTypes.number,
  text: PropTypes.any,
};
function Card({ image, index, text }) {
  return (
    <Box
      alignItems="center"
      display={{ xs: "flex", lg: "block" }}
      mt={{ xs: index ? 4 : 0, lg: 0 }}
    >
      <Box height={{ xs: 64, lg: 88 }} mb={{ lg: 5 }} mr={{ xs: 4 }} width={{ xs: 64, lg: 1 }}>
        <GatsbyImage
          alt=""
          image={image.localFile.childImageSharp.gatsbyImageData}
          imgStyle={{ objectFit: "contain" }}
          style={{ height: "100%" }}
        />
      </Box>
      <Box maxWidth={{ lg: 200 }}>
        <Typography textAlign={{ lg: "center" }} variant="h3">
          {text}
        </Typography>
      </Box>
    </Box>
  );
}

SectionAboutLeasing.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cards: PropTypes.array,
  }),
};
export default function SectionAboutLeasing({ content }) {
  const { cards, description, title } = content;
  return (
    <SectionContainer title={parse(title)}>
      <Typography component="div" sx={{ mb: 5 }} variant="subtitle1">
        <ShowMoreText text={parse(description)} />
      </Typography>
      <Box display={{ lg: "flex" }} justifyContent="space-between">
        {cards.map((card, i) => (
          <Card index={i} key={i} {...card} />
        ))}
      </Box>
    </SectionContainer>
  );
}
